<template>
  <div>
    <div>
      <c-row>
        <c-col col="12">
          <loader v-show="loading"/>
          <c-card>
            <c-card-header>
              <strong>Warranty</strong>
              <div class="card-header-actions">
                <CInput
                  @keyup="doSearch"
                  type="text"
                  placeholder="Ketikkan no garansi atau no Invoice"
                  v-model="q"
                  style="width: 400px"
                  ref="search"
                ></CInput>
              </div>
            </c-card-header>
            <c-card-body>
              <div style="overflow: auto">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th width="10">No</th>
                      <th width="180">No Invoice</th>
                      <th width="130">Warranty</th>
                      <th width="130">Date Sale</th>
                      <th width="130">Warranty Until</th>
                      <th width="300">Item Name</th>
                      <th width="200">Customer Name</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(v, k) in data.data" :key="k">
                      <td><table-number-2 :index="k" :paginate="data.paginate"/></td>
                      <td>{{ v.invoice }}</td>
                      <td>{{ v.warranty }}</td>
                      <td>{{ v.date_sale | dateFormat}} </td>
                      <td>{{ v.out_of_warranty | dateFormat }} </td>
                      <td>{{ v.item_name}} </td>
                      <td>{{ v.customer_name}} </td>
                      <td>
                        <i-button icon="cil-pencil" color="primary" @action="edit(v.warranty_code)"/>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </c-card-body>
            <c-card-footer>
              <paginator :paginator="data.paginate" @change="changePaginator"/>
            </c-card-footer>
          </c-card>
        </c-col>
      </c-row>
    </div>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue';
import Paginator from '../../components/Paginator.vue';
import IButton from '../../components/IButton.vue';
import TableNumber2 from '../../components/TableNumber2.vue';
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from '../../lib/httplib';

export default {
  components: {
    TableNumber2,
    Loader,
    Paginator,
    IButton,
  },
  data () {
    return {
      data: {},
      loading: true,
      q: ''
    }
  },
  created () {
    const q = this.$route.query
    if (q && q.q) {
      this.q = q.q
    }
    if (q && q.page) {
      this.getList(q.page)
    } else {
      this.getList(1)
    }
  },
  methods: {
    changePaginator (page) {
      this.getList(page)
    },
    getList (page) {
      this.loading = true
      HTTPAUTH.get(`/api/v1/warranty/items?q=${this.q}&page=${page}&size=10`).then(res => {
        this.data = res.data
        this.$router.push({query: {page: page, q: this.q}})
        this.loading = false
      }).catch(eres => {
        this.loading = false
        showErrorMessage(eres)
      })
    },
    edit (code) {
      this.$router.push(`/product/warranty/${code}`);
    },
    doSearch () {
      var page = 1
      const query = this.$route.query
      if (query && query.page) {
        page = query.page
      }
      this.getList(page)
    }
  },
  // watch: {
  //   $route(to, from) {

  //   }
  // }
};
</script>